module.exports = __webpack_public_path__ + "../resources/img/qr-ios-home.8c33a0a0.png";